import { useEffect, useState } from "react";
import DashboardReusable from "../UI/DashboardReusable";
import QueryContainer from "./QueryContainer";
import { getQueries } from "../../util/http";
import { useContext } from "react";
import { AuthContext } from "../../util/context";

export default function Query() {
  const [list, setList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);

  const lastIndex = currentPage * perPage;
  const firstIndex = lastIndex - perPage;

  const { user } = useContext(AuthContext);

  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        const response = await getQueries();
        setLoading(false);
        if (
          user.job_role?.toLowerCase() === "lawyer" ||
          user.job_role?.toLowerCase() === "user"
        ) {
          setList(
            response?.queries
              ?.filter((el) => el.assignee_id === user.employee_id)
              .reverse()
          );
        } else if (
          user?.job_role?.toLowerCase().includes("hod") ||
          user?.job_role?.toLowerCase() === "hop"
        ) {
          setList(
            response?.queries
              ?.filter(
                (el) => String(el.initiator_id) === String(user.employee_id)
              )
              .reverse()
          );
        } else {
          setList(response?.queries?.reverse());
        }
      } catch (error) {
        setLoading(false);
        console.log(error);
      }
    }
    fetchData();
  }, []);

  useEffect(() => {
    setTotal(list.length);
  }, [list]);

  const queryList = list.slice(firstIndex, lastIndex);

  return (
    <DashboardReusable>
      <QueryContainer
        list={queryList}
        total={total}
        perPage={perPage}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        setList={setList}
        loading={loading}
      />
    </DashboardReusable>
  );
}
